import Vue from 'vue'
import Router from 'vue-router'
import {store} from '@/store/store'
import {auth} from '@/firebaseConfig'

import Home from '@/views/Home.vue'
import FlightSearchWidget from '@/views/flights/FlightSearchWidget.vue'
import HotelSearchWidget from '@/views/hotels/HotelSearchWidget.vue'


import i18n from "@/i18n";

Vue.use(Router);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
          return savedPosition;
      }
      if (to.hash) {
          return { selector: to.hash };
      }
      return { x: 0, y: 0 };
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { 
      path: '*', 
      redirect: () => `/${window.TravelPlatform.site.display.language}/404`
    },  
    { 
      path: '/', 
      redirect: () => `/${window.TravelPlatform.site.display.language}/`
    },
    {
      path: '/admin',
      redirect: () => `/${window.TravelPlatform.site.display.language}/admin/bookings`
    },
    {
      path: '/:locale/admin',
      redirect: '/:locale/admin/bookings'
    },
    {
      path: '/login',
      redirect: () => `/${window.TravelPlatform.site.display.language}/admin/login`
    },
    {
      path: '/admin/login',
      redirect: () => `/${window.TravelPlatform.site.display.language}/admin/login`
    },
    {
      path: '/hotels',
      redirect: () => `/${window.TravelPlatform.site.display.language}/`
    },
    {
      path: '/flights',
      redirect: () => `/${window.TravelPlatform.site.display.language}/`
    },
    {
      path: '/:locale/',
      name: 'Home',
      component: Home
    },
    {
      path: '/:locale/flights/search/:currency/:origin/:destination/:departureDate/:returnDate?',
      name: 'FlightsList',
      component: () => import (/* webpackChunkName: "flightsList" */ '@/views/flights/FlightsList.vue')
    },
    {
      path: '/:locale/flights/book/:id',
      name: 'FlightsBooking',
      component: () => import (/* webpackChunkName: "flightsBooking" */ '@/views/flights/FlightsBooking.vue')
    },

    {
      path: '/:locale/flights/bookContinue/:paymentReference/:amountToPay',
      name: 'FlightsBookingContinue',
      component: () => import (/* webpackChunkName: "flightsBookingContinue" */ '@/views/flights/FlightsBookingContinue.vue')
    },

    {
      path: '/flight-search-widget',
      redirect: () => `/${window.TravelPlatform.site.display.language}/flight-search-widget`
    },
    {
      path: '/:locale/flight-search-widget',
      name: 'FlightSearchWidget',
      component: FlightSearchWidget,
    },
    {
      path: '/:locale/hotels/search/:currency/:destinationType-:destinationName/:destination/:checkIn/:checkOut?',
      name: 'HotelsList',
      component: () => import (/* webpackChunkName: "hotelsList" */ '@/views/hotels/HotelsList.vue')
    },
    {
      path: '/:locale/hotels/listing/:id/:currency?',
      name: 'HotelListingNoDates',
      component: () => import (/* webpackChunkName: "hotelListing" */ '@/views/hotels/HotelListing.vue')
    },
    {
      path: '/:locale/hotels/listing/:id/:currency/:checkIn/:checkOut?',
      name: 'HotelListing',
      component: () => import (/* webpackChunkName: "hotelListing" */ '@/views/hotels/HotelListing.vue')
    },
    {
      path: '/:locale/hotels/book/:ppn',
      name: 'HotelBooking',
      component: () => import (/* webpackChunkName: "hotelBooking" */ '@/views/hotels/HotelBooking.vue')
    },
    {
      path: '/hotel-search-widget',
      redirect: () => `/${window.TravelPlatform.site.display.language}/hotel-search-widget`
    },
    {
      path: '/:locale/hotel-search-widget',
      name: 'HotelSearchWidget',
      component: HotelSearchWidget
    },
    {
      path: '/bookings/hotels/:bookingId/:email',
      redirect: () => `/${window.TravelPlatform.site.display.language}/bookings/hotels/:bookingId/:email`
    },
    {
      path: '/:locale/bookings/hotels/:bookingId/:email',
      name: 'EditHotelBooking',
      component: () => import (/* webpackChunkName: "editHotelBooking" */ '@/views/hotels/EditHotelBooking.vue'),
      props: true
    },
    {
      path: '/bookings/:orderReference/:email',
      redirect: () => `/${window.TravelPlatform.site.display.language}/bookings/:orderReference/:email`,
    },
    {
      path: '/:locale/bookings/:orderReference/:email',
      name: 'EditFlightBooking',
      component: () => import (/* webpackChunkName: "editFlightBooking" */ '@/views/flights/EditFlightBooking.vue'),
    },
    {
      path: '/myOrders/*',
      redirect: () => `/${window.TravelPlatform.site.display.language}/bookings/*`
    },
    {
      path: '/terms',
      redirect: () => `/${window.TravelPlatform.site.display.language}/terms`
    },
    {
      path: '/:locale/terms',
      name: 'Terms',
      component: () => import (/* webpackChunkName: "termsPage" */ '@/views/TermsPage.vue')
    },
    {
      path: '/privacy',
      redirect: () => `/${window.TravelPlatform.site.display.language}/privacy`
    },
    {
      path: '/:locale/privacy',
      name: 'Privacy',
      component: () => import (/* webpackChunkName: "privacyPage" */ '@/views/PrivacyPage.vue')
    },
    {
      path: '/:locale/support',
      name: 'SupportPage',
      component: () => import (/* webpackChunkName: "supportPage" */ '@/views/support/Support.vue')
    },
    {
      path: '/:locale/support/hotels',
      name: 'HotelsSupport',
      component: () => import (/* webpackChunkName: "hotelsSupport" */ '@/views/support/HotelsSupport.vue')
    },
    {
      path: '/:locale/support/flights',
      name: 'FlightsSupport',
      component: () => import (/* webpackChunkName: "flightsSupport" */ '@/views/support/FlightsSupport.vue')
    },
    {
      path: '/:locale/admin/bookings',
      name: 'Bookings',
      component: () => import (/* webpackChunkName: "bookings" */ '@/views/admin/Bookings.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:locale/admin/account',
      name: 'Account',
      component: () => import (/* webpackChunkName: "account" */ '@/views/admin/account/Account'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:locale/admin/login',
      name: 'Login',
      component: () => import (/* webpackChunkName: "login" */ '@/views/admin/Login.vue'),
    },
    {
      path: '/:locale/admin/logout',
      name: 'Logout',
      component: () => import (/* webpackChunkName: "logout" */ '@/views/admin/Logout.vue'),
    }
  ]
});

router.beforeEach(async (to, from, next) => {

  if (to.params.locale !== i18n.locale) {
    i18n.locale = to.params.locale;
  }

  let currentUser = auth.currentUser;
  let getCurrentUser = store.getters.getCurrentUser;

  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (to.name == 'Login' || !requiresAuth) {
    next();
  }
  else if (!currentUser && !getCurrentUser) {
    next('/login');
  }
  else {
    if (currentUser && !store.getters.getCurrentUser) {
      let tokenResult = await currentUser.getIdTokenResult();
      await store.dispatch('setCurrentUser', tokenResult);
    }
    getCurrentUser = store.getters.getCurrentUser;
    if ((getCurrentUser && getCurrentUser.claims && getCurrentUser.claims.role === 'su') ||
      (getCurrentUser && getCurrentUser.claims && getCurrentUser.claims.agency === window.TravelPlatForm.key)) {
      next();
    }
    else {
      next('/logout');
    }
  }
});

export default router;


